import Vue from 'vue'
import Vuex from 'vuex'
import { getAvatar, getId, getUserName } from '../utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userName: '',
    userId: '',
    avatarUrl: '',
    login: false,
    needWechatLogin: false,
    bindFlag: false,
    isBarcodeShow: false
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.userName = name
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_AVATAR_URL: (state, avatarUrl) => {
      state.avatarUrl = avatarUrl
    },
    SET_LOGIN_STATE: (state, loginState) => {
      state.login = loginState
    },
    SET_WECHAT_LOGIN: (state, needLogin) => {
      state.needWechatLogin = needLogin
    },
    SET_BINDFLAG: (state, bindFlag) => {
      state.bindFlag = bindFlag
    },
    SET_BARCODESHOW: (state, name) => {
      state.isBarcodeShow = name
    }
  },
  getters: {
    getLogin (state) {
      if (!state.login) {
        state.login = getId()
      }
      return state.login
    },
    getUserName (state) {
      if (!state.userName) {
        state.userName = getUserName()
      }
      return state.userName
    },
    getavatarUrl (state) {
      if (!state.avatarUrl) {
        state.avatarUrl = getAvatar()
      }
      return state.avatarUrl
    }
  },
  actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js